var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgLogoSmall = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 27,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0 .012 17.363c0 .339.02.678.07 1.016.062.46.18 1.004.43 1.574.63 1.432 1.38 2.283 2.092 3.012 1.43 1.458 2.853 2.2 3.827 2.692A17.4 17.4 0 0 0 9.997 27a17.463 17.463 0 0 0 3.572-1.343c.974-.499 2.397-1.234 3.827-2.692.712-.723 1.455-1.573 2.092-3.012.25-.57.368-1.113.43-1.574a9.11 9.11 0 0 0 .07-1.016L20 0H0zm18.158 1.88-.006 5.129H1.836L1.83 1.88h16.328zm-.006 11.428a9.995 9.995 0 0 0-1.38-.32c-.287-.044-1.468-.217-3.135-.019-.737.09-1.405.262-2.735.601-.974.25-1.773.48-2.341.646-1.212.435-3.204.928-5.476.41a8.691 8.691 0 0 1-1.243-.384l-.006-5.36h16.316v4.426zM12.907 23.93c-.693.352-1.674.78-2.916 1.1a14.207 14.207 0 0 1-2.916-1.1c-.169-.083-.35-.179-.544-.281l3.447-2.04 3.453 2.046a10.44 10.44 0 0 1-.524.275zm5.238-6.714c0 .179-.006.358-.024.537a4.976 4.976 0 0 1-.381 1.522c-.519 1.17-1.124 1.867-1.705 2.462a9.73 9.73 0 0 1-.83.754l-.082-.05-5.132-3.038-5.14 3.037-.074.045a10.597 10.597 0 0 1-.824-.748c-.581-.595-1.193-1.286-1.705-2.462a4.943 4.943 0 0 1-.381-1.522 5.155 5.155 0 0 1-.025-.537v-1.01c.331.101.8.223 1.361.312.287.045 1.468.218 3.135.02.737-.09 1.405-.263 2.735-.601a69.64 69.64 0 0 0 2.341-.646c1.212-.435 3.204-.928 5.476-.41.456.103.875.237 1.262.384l-.007 1.95z",
    fill: "#FFF"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogoSmall, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo-small.764e22a8.svg";
export { ForwardRef as ReactComponent };